import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-custom-url',
  templateUrl: './custom-url.component.html',
  styleUrls: ['./custom-url.component.scss']
})
export class CustomUrlComponent implements OnInit {
  accessToken: any;
  siteData: any;
  selected: any;
  router: any;
  theme: any;
  activeLink: string = 'QUERY';
  startDate!: string;
  endDate!: string;
  queryData: any;
  selectedQueries: any[] = [];
  @Input() linkData: any
  @Input() html: any;
  @Input() id?: string
  isTokenExpire: boolean = false;

  constructor(private editorServie: EditorService,
    private toastr: ToastrService,
    private themingService: ThemingService,
    private activeModal: NgbActiveModal) {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    });
  }
  get selectMenu() {
    return !this.theme ? 'testClass' : 'selectMenu'
  }
  ngOnInit(): void {
    this.themingService.pingThemeName();
    if('google_token' in localStorage){
      this.accessToken = JSON.parse(localStorage?.getItem('google_token') || '');
      this.getSiteLists();
      this.linkData = this.linkData?.map((el:any)=>el.keys[0])

    }else{
      this.isTokenExpire = true;
    }

  }
  getSiteLists() {
    this.editorServie.getSites(this.accessToken).subscribe((res: any) => {
      this.siteData = res.siteEntry;
      this.selected = res.siteEntry[0].siteUrl;
      this.getQueryUrl();
    }, (err: any) => {
      if (!!err && !!err?.error?.error?.code && err?.error?.error?.code == 401) {
        localStorage.removeItem('google_token');
        // this.activeModal.dismiss();
        this.isTokenExpire = true;
        // this.toastr.error('Token Expire');
        this.queryData=[];
      }else{
        // this.toastr.error(err?.error?.error?.message);
        this.isTokenExpire = false;
        this.queryData=[];
      }
    })
  }
  getQueryUrl() {
    var today = new Date();
    var d = new Date();
    d.setDate(d.getDate() - 28);
    this.startDate = d.toLocaleDateString('en-CA');
    this.endDate = new Date().toLocaleDateString('en-CA');
    let dateObj = {
      startDate: this.startDate,
      endDate: this.endDate,
      "dimensions": [
        "QUERY",
        "PAGE"
      ],
      "rowLimit": 1000,
      "startRow": 0
    }
    this.editorServie.getSiteData(this.selected, this.accessToken, dateObj).subscribe((res: any) => {
      res.rows = res.rows.map((e: any) => {
        return {
          ...e,
          isChecked: this.linkData.includes(e.keys[0]) ? true : false
        }
      });
      let queryArr:any = [];
      this.html!.childNodes.forEach((el: any) => {
        // el.style.color = "transparent";
        if (el.tagName === "P" || el.tagName === "TABLE") {
          let tempHtml = el.innerHTML;
          res?.rows?.forEach((el: any, index: any) => {
            var re = new RegExp("(?<!\\w)" + el?.keys[0] + "(?!\\w)", "gi");
    
            tempHtml = tempHtml.replaceAll(re, (matched: any) => {
              queryArr.push(matched);
              // return `<a href="${el.keys[1]}" target="_blank" style="text-decoration:underline;pointer-events:auto">${matched}</a>`
            });
          })
          // el.innerHTML = tempHtml;
        }
      });
      let newQueryArr:any = [...new Set(queryArr)]
      this.queryData = res.rows.filter((el:any)=>{return newQueryArr.includes(el.keys[0])});
    }, (err: any) => {
      if (!!err && !!err?.error?.error?.code && err?.error?.error?.code == 401) {
        localStorage.removeItem('google_token');
        // this.activeModal.dismiss();
        // this.toastr.error('Token Expire');
        this.queryData=[];
        this.isTokenExpire = true;
        // this.getNewAccessToken();
        // this.router.navigate(['/dashboard/integration'])
      }else{
        // this.toastr.error(err?.error?.error?.message);
        this.queryData=[];
        this.isTokenExpire = false;
      }
    })
  }
  changeData(title: any) {
    this.activeLink = title;
    this.getQueryUrl();
  }
  changeActiveLink(arg: string) {

  }
  closeModal() {
    this.activeModal.dismiss();
  }
  applyChanges() {
    console.log(this.queryData);
    this.activeModal.close({ data: this.queryData.filter((el: any) => el.isChecked).map((ell:any)=>{return {keys:ell.keys}}) });
  }
  authorize(){
    const authUrl: any = this.editorServie.authorizes(this.id)
      window.location.href = authUrl;
  }
}
